import { NgModule } from '@angular/core';
import { RegisterButtonsComponent } from './register-buttons/register-buttons.component';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
  ],
  declarations: [
    RegisterButtonsComponent,
  ],
  exports: [
    RegisterButtonsComponent,
  ]
})
export class RegisterButtonsModule { }